const n = {
  light: "on-light",
  dark: "on-dark",
  "accent-soft": "on-soft",
  "accent-warm": "on-warm",
  "accent-vibrant": "on-vibrant",
  // Added to support all container colors but not actually used
  primary: "on-light"
};
export {
  n as SHAPE_COLOR_MAPPING
};
